export default "__VITE_ASSET__071eaf35__"